import React from 'react';
import PropTypes from 'prop-types';
import firebase from "../config/firebase";
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import HealingIcon from '@material-ui/icons/Healing';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import CallIcon from '@material-ui/icons/Call';
import LockIcon from '@material-ui/icons/Lock';
import ContactsIcon from '@material-ui/icons/Contacts';
import { withStyles, makeStyles , useTheme} from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Zoom from '@material-ui/core/Zoom';

import CircularProgress from '@material-ui/core/CircularProgress';
import { Table, TableRow, TableFooter, TableCell, TableHead, TableBody,
         Divider, Container, Grid, Drawer, Button,
         Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
         List, ListItem, ListItemText, ListItemAvatar, Avatar
        } from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import SidebarNav from './Sidebar.js';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.light,
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <> 
    <br></br>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


const drawerWidth = 240; 

const useStyles = makeStyles((theme) => ({
    root: {
    flexGrow: 1,
    margin:theme.spacing(0),
    padding:theme.spacing(0),
    },
    title: {
    flexGrow: 1,
    textAlign:'left'
    },
    imgLogo: {
      width: "50px",
      marginRight: theme.spacing(1)
    }, 
    button: {
        margin: theme.spacing(1),
        float: 'right'
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginRight: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      marginTop: theme.spacing(1),
      padding: theme.spacing(0),
      paddingLeft: theme.spacing(2),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: 0,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    nav: {
      marginBottom: theme.spacing(2)
    },
    
 }));

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}
  

const handlelogout = () => {
  firebase.auth().signOut().then(function() {
  }).catch(function(error) {
      console.log(error)
  });
};



function Volunteers (props) {
    
    const classes = useStyles();
    const theme = useTheme();

    const [voluntarios, setVoluntarios] = React.useState([]);
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };

    const GetBase = () => {
    
      return (
      <>
        <CssBaseline />
        <AppBar position="sticky" color="default" 
          className={clsx(classes.appBar, {[classes.appBarShift]: open, })}
        >
        <Toolbar id="back-to-top-anchor" >
          <img className={classes.imgLogo} src={require('../assets/img/logo.png')} />
          <Typography className={classes.title} variant="h6">Unidos Para Ayudar</Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="right"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <SidebarNav 
          className={classes.nav} 
          />
        </Drawer>
      </>
      );
    };

    const fetchData = async () => {
      const db = firebase.firestore().collection('orgs').doc('unidos');
      const data = await db.collection("users")
            .orderBy("cedula", "asc")
            .get();
      setVoluntarios(data.docs.map(x => ({...x.data(), id:x.id})));
    };

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const [openCuarentena, setOpenCuarentena] = React.useState(false);
    const [voluntarioSel, setVoluntarioSel]   = React.useState(null);
    const handleCuarentenaOpen = (vol) => {
      setVoluntarioSel(vol)
      setOpenCuarentena(true);
    };

    const handleCuarentenaClose = () => {
      setVoluntarioSel(null)
      setOpenCuarentena(false);
    };
   
    const handleCuarentenaConfirm = () => {
      var uidRef = firebase.firestore().collection('orgs').doc('unidos').collection('users').doc(voluntarioSel.id)
      var vecRef = firebase.firestore().collection('orgs').doc('unidos').collection('vectores').doc()
      var vector = {
          'voluntarioId' : voluntarioSel.id,
          'voluntarioNombre' : voluntarioSel.nombre + " " + voluntarioSel.apellido,
          'fechaAlerta'  :  firebase.firestore.FieldValue.serverTimestamp(),
          'estado'       : "Pendiente"
      }
      return firebase.firestore().runTransaction(function(transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(uidRef).then(function(userDoc) {
              if (!userDoc.exists) {
                  throw "User does not exist!";
              }
              transaction.update(uidRef, { 'covid': 2 , 'fechaAlerta': firebase.firestore.FieldValue.serverTimestamp()});   
              transaction.set(vecRef, vector);
              setOpenCuarentena(false);
              })
      }).then(function() {
          fetchData();
      }).catch(function(error) {
          console.log("Transaction failed: ", error);
      });
    }
  
    const showDialogCuarentena = () => {
      if (!voluntarioSel)
        return (
          <></>
        )
      return (
        <>
      <Dialog open={openCuarentena} onClose={handleCuarentenaClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Activar cuarenentena</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Al confirmar iniciará la cuarentena para el voluntario <b>{voluntarioSel.nombre} {voluntarioSel.apellido}</b> con e-mail <b>{voluntarioSel.email}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCuarentenaClose} color="primary">
            Cancelar
          </Button>
          <Button  onClick={handleCuarentenaConfirm}  color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      </>
      )  
    }

    const [openVoluntario, setOpenVoluntario] = React.useState(false);
    const handleVoluntarioOpen = (vol) => {
      setVoluntarioSel(vol)
      setOpenVoluntario(true);
    };

    const handleVoluntarioClose = () => {
      setVoluntarioSel(null)
      setOpenVoluntario(false);
    };

    const sendPasswordReset = () => {
      var actionCodeSettings = {
         url: "https://unidosparaayudar.web.app/login",
      };
      firebase.auth().sendPasswordResetEmail(
          voluntarioSel.email, actionCodeSettings)
      .then(function() {
        setOpenVoluntario(false);
        alert("Exito")
      })
      .catch(function(error) {
        alert("Error al reestablecer contraseña")
        console.log(error)
      });
    }
    
    const showDialogVoluntario = () => {
      if (!voluntarioSel)
        return (
          <></>
        )
      return (
        <>
      <Dialog open={openVoluntario} onClose={handleVoluntarioClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Datos de Voluntario</DialogTitle>
        <DialogContent>
          <List className={classes.root}>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <ContactsIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={voluntarioSel.nombre + " " + voluntarioSel.apellido} secondary="Nombre" />
            </ListItem>
            <CopyToClipboard text={voluntarioSel.cedula}>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <ContactsIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={voluntarioSel.cedula} secondary="Cedula" />
            </ListItem>
            </CopyToClipboard>
            <CopyToClipboard text={voluntarioSel.celular}>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <CallIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={voluntarioSel.celular} secondary="Celular" />
            </ListItem>
            </CopyToClipboard>
            <CopyToClipboard text={voluntarioSel.email}>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AlternateEmailIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={voluntarioSel.email} secondary="Email" />
            </ListItem>
            </CopyToClipboard>
            <ListItem>
              <Button onClick={sendPasswordReset} color="secondary" startIcon={<LockIcon />}>
              Reestablecer 
              </Button>
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleVoluntarioClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      </>
      )
      
    }

    const showHealing = (vol) => {
      if (!vol.covid || vol.covid === 0) {
        return (
          <Button onClick={() => handleCuarentenaOpen(vol)}>
              <HealingIcon />
          </Button>
        );
      }
      return (
        <Button disabled>
        <HealingIcon color="secondary" />
        </Button>
      );
    }

    React.useEffect(() => {
      fetchData()
    }, []);

    if (!voluntarios)
      return (
        <div className={classes.root}>
          { GetBase() }
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
          <Typography component="h1" variant="h5">
          Listado de Voluntarios
          </Typography>
          <br></br>
          <Container spacing={2}>
          <CircularProgress />
          </Container>
          </main>
          </div>
      );

    
    return (
        <div className={classes.root}>
        { GetBase() }
        <main
              className={clsx(classes.content, {
                [classes.contentShift]: open,
              })}
            >
        <Typography component="h1" variant="h5">
          Listado de Voluntarios
        </Typography>
        <br></br>
      <Table className={classes.table} size="small" aria-label="Voluntarios">
        <TableHead>
          <StyledTableRow>
          <StyledTableCell></StyledTableCell>
          <StyledTableCell>Apellido</StyledTableCell>
          <StyledTableCell>Nombre</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>         
              {(rowsPerPage > 0
                ? voluntarios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : voluntarios
              ).map(
              (vol, index ) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row" align="right">
                    <Grid container>
                      <Grid item>
                        { showHealing(vol) } 
                      </Grid>
                      <Grid item>
                        <Button onClick={() => handleVoluntarioOpen(vol)}>
                          <AccountBoxIcon />
                        </Button>
                      </Grid>
                    </Grid>
                    </StyledTableCell>
                    <StyledTableCell >
                      {vol.apellido}
                    </StyledTableCell>
                    <StyledTableCell >{vol.nombre}</StyledTableCell>
                  </StyledTableRow>
                )
              )
        }
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100, { label: 'All', value: -1 }]}
              colSpan={3}
              count={voluntarios.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
      <ScrollTop {...props}>
      <Fab color="secondary" size="small" aria-label="scroll back to top">
        <KeyboardArrowUpIcon />
      </Fab>
      </ScrollTop>
      { showDialogCuarentena() }
      { showDialogVoluntario() }
      </main> 
      </div>
    );

}

export default Volunteers;